const o = {
  size: "medium",
  color: "--color-secondary-100"
};
export { o as spinnerDefaultProps };